module.exports = __webpack_public_path__ + "static/media/bitmoji.50148f84.png";